import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import * as React from "react";

/**
 * The properties for an AbItem component.
 */

/**
 * A component that can render an item with an icon and a label.
 */
export const AbItem = props => {
  const labelRef = React.useRef(null);
  const contextSize = React.useContext(AbSizeContext);
  const renderIcon = icon => {
    if (typeof icon === "string") {
      return /*#__PURE__*/React.createElement(AbIcon, {
        className: "ab-item-icon",
        image: icon
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ab-item-icon"
    }, icon);
  };
  const inner = /*#__PURE__*/React.createElement(AbWithTooltip, _extends({
    clippedTrigger: labelRef
  }, AbWithTooltip.makeClippedProps(props.tooltip, props.label)), /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-item", props, [props.size ?? contextSize, !!(props.icon && props.label) && "ab-item-spacing"]), props.eventHandlers), props.icon && renderIcon(props.icon), props.label && /*#__PURE__*/React.createElement("div", {
    className: "ab-item-label",
    ref: labelRef
  }, props.label)));
  return sizeProviderWrapper(inner, props, contextSize);
};
//# sourceMappingURL=AbItem.js.map
